export const commonKeywords = [
    "xsiadron",
    "Lukasz Frydrych",
    "Luke Frydrych",
    "Luke xsiadron Frydrych",
];
